import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateRevisionStatusRequest, IGetRevisionStatusResponse, IUpdateRevisionStatusRequest } from '../models/revision-status';


@Injectable({
  providedIn: 'root'
})
export class RevisionStatusService {

  constructor(private http: HttpClient) { }




  // Revision Status
  createRevisionStatus(request: ICreateRevisionStatusRequest) {
    return this.http.post<IGetRevisionStatusResponse>(
      `${environment.baseUrl}/v1/revisionStatus/createRevisionStatus`,
      request
    )
  }

  getRevisionStatusGlobal(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IGetRevisionStatusResponse[]>>(
      `${environment.baseUrl}/v1/revisionStatus/getRevisionStatus`,
      request
    )
  }

  getRevisionStatusById(id: string){
    return this.http.get<IGetRevisionStatusResponse>(
      `${environment.baseUrl}/v1/revisionStatus/getRevisionStatus/${id}`
    )
  }

  updateRevisionStatus(request: IUpdateRevisionStatusRequest){
    return this.http.put<IGetRevisionStatusResponse>(
      `${environment.baseUrl}/v1/revisionStatus/updateRevisionStatus/${request.id}`,
      request
    )
  }

  deleteRevisionStatus(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/revisionStatus/deleteRevisionStatus/${id}`
    )
  }
}
